import {Injectable} from '@angular/core';
import {Observable, of, Subject} from "rxjs";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {SnackBarService} from "../../../../@core/services/snack-bar.service";
import {catchError, switchMap} from "rxjs/operators";
import {environment} from "../../../../../environments/environment";
import {UserService} from "../../../../@shared/services/user.service";
import {IXpHistory} from "./interfaces/xp-history.interface";

@Injectable()
export class UserXpHistoryService {

  private readonly userXpHistoryRequest: Subject<any> = new Subject<any>();
  private readonly userXpHistory: Subject<IXpHistory> = new Subject<IXpHistory>();
  public readonly userXpHistory$: Observable<IXpHistory> = this.userXpHistory.asObservable();

  constructor(private readonly http: HttpClient,
              private readonly userService: UserService,
              private sb: SnackBarService) {
    this.subscribeEmitters();
  }

  public requestUserXpHistory(dateForm: { start: string, end: string }, pageSize: number, currentPage: number): void {
    this.userXpHistoryRequest.next({dateForm, pageSize, currentPage});
  }

  public resetUserXpBonuses(comment: string): Observable<any> {
    return this.http.post(`${environment.GATEWAY_URL}/user/${this.userService.currentUserId.getValue()}/xp-reset`, {comment})
      .pipe(catchError((error: HttpErrorResponse) => this.onHandleError(error)));
  }

  public setStoreWithdrawLimit(withDrawLimitForm: { withdrawLimit: number, reason: string }): Observable<any> {
    return this.http.patch(`${environment.GATEWAY_URL}/user/${this.userService.currentUserId.getValue()}/store-withdraw-limit`,
      withDrawLimitForm)
      .pipe(catchError((error: HttpErrorResponse) => this.onHandleError(error)));
  }

  public addXp(amount: number, comment: string): Observable<any> {
    return this.http.post(`${environment.GATEWAY_URL}/user/${this.userService.currentUserId.getValue()}/add-xp`, {
      amount,
      comment
    })
      .pipe(catchError((error: HttpErrorResponse) => this.onHandleError(error)));
  }

  private subscribeEmitters(): void {
    this.userXpHistoryRequest.pipe(
      switchMap((params) => this.http.get(`${environment.GATEWAY_URL}/user/xp-history/${this.userService.currentUserId.getValue()}?startDate=${params.dateForm.start}&endDate=${params.dateForm.end}&page[size]=${params.pageSize}&page[number]=${params.currentPage + 1}`,
        {withCredentials: true})
        .pipe(catchError((error: HttpErrorResponse) => this.onHandleError(error)))),
    ).subscribe((userXpHistory: any) => this.userXpHistory.next(userXpHistory));
  }

  private onHandleError(error: HttpErrorResponse): Observable<null> {
    const message = error.error.statusCode + ' ' + (error.error.message || error.error.error);
    this.sb.openSnackBar(message, 3000, 'error');
    return of(null);
  }
}

